import dot from 'dot-prop-immutable';
import { denormalize } from 'normalizr';
import reduceReducers from 'reduce-reducers';

import { createEntitiesReducer } from 'modules/common/redux';

import { types } from './actions';
import { customInterrogationSchema } from './entities';

const initialState = {
  entities: {},
  customInterrogation: null,
  isDeleting: false,
  isInputEditorOpen: false,
  isUpdating: false,
  isSelectorModalOpen: {
    materialClass: false,
    materialFamily: false,
    material: false,
    operationDefinition: false,
  },
};

const entitiesReducer = createEntitiesReducer(
  [
    'customInterrogations',
    'materialClasses',
    'materialFamilies',
    'materials',
    'operationDefinitions',
  ],
  [types.RECEIVE_CUSTOM_INTERROGATION, types.UPDATE_INTERROGATION_SUCCESS],
);

const reducer = (state, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.RECEIVE_CUSTOM_INTERROGATION:
      return {
        ...state,
        customInterrogation: payload.result,
      };
    case types.OPEN_INPUTS_EDITOR:
      return {
        ...state,
        isInputEditorOpen: true,
      };
    case types.CLOSE_INPUTS_EDITOR:
      return {
        ...state,
        isInputEditorOpen: false,
      };
    case types.UPDATE_INTERROGATION_REQUEST:
      return {
        ...state,
        isUpdating: true,
      };
    case types.UPDATE_INTERROGATION_SUCCESS:
    case types.UPDATE_INTERROGATION_ERROR:
      return {
        ...state,
        isUpdating: false,
      };
    case types.OPEN_SELECTOR_MODAL:
      return dot.set(
        state,
        `isSelectorModalOpen.${payload.selectorType}`,
        true,
      );
    case types.CLOSE_SELECTOR_MODAL:
      return dot.set(
        state,
        `isSelectorModalOpen.${payload.selectorType}`,
        false,
      );
    case types.DELETE_INTERROGATION_ERROR:
    case types.DELETE_INTERROGATION_SUCCESS:
      return {
        ...state,
        isDeleting: false,
      };
    case types.DELETE_INTERROGATION_REQUEST:
      return {
        ...state,
        isDeleting: true,
      };
    default:
      return state;
  }
};

export default reduceReducers(entitiesReducer, reducer, initialState);

const getScope = (state) => state.modules.customInterrogations.detailsPage;

export const getCustomInterrogation = (state) => {
  return denormalize(
    getScope(state).customInterrogation,
    customInterrogationSchema,
    getScope(state).entities,
  );
};

export const getIsInterrogationDeleting = (state) => getScope(state).isDeleting;

export const getIsInputEditorOpen = (state) =>
  getScope(state).isInputEditorOpen;

export const getIsUpdating = (state) => getScope(state).isUpdating;

export const getIsSelectorModalOpen = (state, type) =>
  getScope(state).isSelectorModalOpen[type];
